export default "__VITE_ASSET__77e9312f__"